module.exports = __webpack_public_path__ + "prod/1.42.2/img/hema-icon.2b4780b9.png";